<template>
  <v-row no-gutters>
    <v-col class="cards-wrap" cols="9">
      <v-row no-gutters>
        <v-col cols="12" lg="4" class="chart-card-wrap">
          <div class="chart-card">
            <a href="#onboarding">
              <v-card-title class="chart-title">
                Onboarding
              </v-card-title>
              <v-card-text class="chart-desc">
                <span>New employees,</span>
                <span style="color: #050550;font-weight:bold">&nbsp;0-3&nbsp;</span>
                <span>months after starting.</span>
              </v-card-text>
            </a>
          </div>
        </v-col>
        <v-col cols="12" lg="4" class="chart-card-wrap">
          <div class="chart-card">
            <a href="#initial">
              <v-card-title class="chart-title">
                Initial development
              </v-card-title>
              <v-card-text class="chart-desc">
                <span>Employees in the organization for</span>
                <span style="color: #050550;font-weight:bold">&nbsp;3-24&nbsp;</span>
                <span>months.</span>
              </v-card-text>
            </a>
          </div>
        </v-col>
        <v-col cols="12" lg="4" class="chart-card-wrap">
          <div class="chart-card">
            <a href="#ongoing">
              <v-card-title class="chart-title">
                Ongoing development
              </v-card-title>
              <v-card-text class="chart-desc">
                <span>Employees in the organization for</span>
                <span style="color: #050550;font-weight:bold">&nbsp;24+&nbsp;</span>
                <span>months.</span>
              </v-card-text>
            </a>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" lg="3" class="chart-card-wrap pl-10">
      <div class="chart-card last-card">
        <a href="#separation">
          <v-card-title class="chart-title">
            Separation
          </v-card-title>
          <v-card-text class="chart-desc">
            The final period of the employment.
            <p class="pa-4 pt-3 d-flex align-center" style="height:10rem;">Not enough data to generate report</p>
          </v-card-text>
        </a>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'avgEngagement'
};
</script>

<style lang="scss" scoped>
.cards-wrap {
  box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
  .chart-card {
    box-shadow: 0 1px 1px 1px rgba(0,0,0,.06), 0 1px 1px rgba(0,0,0,.08) !important;
  }
}
.chart-card-wrap {
  // padding: 1px;
  .chart-card {
    height: 15rem;
    background-color: var(--bg);
    // box-shadow: 0 1px 1px 1px rgba(0,0,0,.06), 0 1px 1px rgba(0,0,0,.08) !important;
    // border-radius: 0px !important;
    // transform: scale(0.97)!important;
    .chart-title {
      // color: #050550;
      // color: var(--primary-color);
      font-weight: 500;
      // font-size: 15px;
      font-size: var(--content-size);
      color: var(--color-text);
      line-height: 1;
      padding-bottom: 0!important;
    }
    .chart-desc {
      padding-top: 4px !important;
      // color: #b1bbc4;
      color: var(--color-palceholder);
      font-weight: 400;
      // font-size: 12px;
      font-size: var(--content-sub-size);
    }
    a {
      text-decoration: none;
    }
    // &:hover {
    //   transition: 0.5s ease all;
    // }
  }
}
.last-card {
  position: relative;
  // left: 20px;
  // width: 93%;
  // padding-left: 20px;
  box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
  &:hover {
    color: var(--bg);
    // background: linear-gradient(90deg, #42276f, #911f42);
    // background: linear-gradient(90deg, rgb(130,90,197), rgb(217,77,120));
    background: #584475;
    background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
  }
  &:hover .chart-title {
    color: var(--bg);
  }
  &:hover .chart-desc {
    color: var(--bg);
  }
}
</style>
